module.exports = __webpack_public_path__ + "static/media/logo-conciliador-branca-nova.fa3f5262.png";